import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { userHasBookings } from 'src/api/userService';

import { queryRetry } from '../query-retry';

export const useGetUserHasBookings = (userLoggedIn: boolean) => {
    const query = useQuery<boolean, AxiosError>({
        enabled: userLoggedIn,
        queryKey: ['userHasBookings'],
        queryFn: () => userHasBookings(),
        retry: queryRetry,
    });

    return {
        ...query,
    };
};
